<div class="store-modal">
	<div>
		<span [cmLocalize]="locFeature + '/System.CookieModal.Content.Policy'" [htmlAllowed]="true">
			We use stores that improve your experience with the website, keep statistics to optimize performance, and
			allow for interaction with other platforms. For more information please view our
		</span>
		<a href="https://www.alpinetesting.com/privacypolicy/" target="_blank" class="inline-block ml-4 inline-link">
			<span [cmLocalize]="locFeature + '/System.CookieModal.Content.PolicyLinkText'">
				Privacy Statement
			</span>
		</a>
	</div>
	<button mat-button class="ml-32" (click)="accept()">
		<span [cmLocalize]="locFeature + '/System.CookieModal.Button.AcceptButton'">
			OK
		</span>
	</button>
</div>
